import * as React from 'react';
import { useDayPicker } from '../../contexts';
import { getWeekdays } from './utils';
/**
 * Render the Head component - i.e. the table head with the weekday names.
 */
export function Head() {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles, showWeekNumber = _a.showWeekNumber, locale = _a.locale, formatWeekdayName = _a.formatters.formatWeekdayName, labelWeekday = _a.labels.labelWeekday;
    var weekdays = getWeekdays(locale);
    return (React.createElement("thead", { style: styles.head, className: classNames.head },
        React.createElement("tr", { style: styles.head_row, className: classNames.head_row },
            showWeekNumber && (React.createElement("th", { scope: "col", style: styles.head_cell, className: classNames.head_cell })),
            weekdays.map(function (weekday, i) { return (React.createElement("th", { key: i, scope: "col", className: classNames.head_cell, style: styles.head_cell },
                React.createElement("span", { className: classNames.vhidden, "aria-label": "" }, labelWeekday(weekday, { locale: locale })),
                React.createElement("span", { "aria-hidden": true }, formatWeekdayName(weekday, { locale: locale })))); }))));
}
//# sourceMappingURL=Head.js.map